import Nullstack from 'nullstack';
export default function IconBlurOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-blur-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v5m0 4v8"
  }), "   ", Nullstack.element("path", {
    d: "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h5"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h7"
  }), "   ", Nullstack.element("path", {
    d: "M12 6h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 18h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 15h3m4 0h1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}